import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Box, Button, Typography } from "@mui/material";
import { t } from "i18next";
import { pageTitle } from "@/components/document-title";
import { Flex } from "@/components/layout/flex/flex";
import { useAuth } from "@/lib/keycloak";
import { usePlatform } from "@/hooks/use-platform/use-platform";

export const Route = createFileRoute("/unauthorized")({
	head: () => pageTitle("Unauthorized Access"),
	component: UnauthorizedPage,
});

function UnauthorizedPage() {
	const navigate = useNavigate();
	const { noAvailablePlatforms } = usePlatform();
	const { authenticated, logout } = useAuth();

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100dvh",
				gap: 2,
			}}
		>
			<Typography variant="h4">{t("Unauthorized Access")}</Typography>
			<Typography variant="body1" color="text.secondary">
				{t("You don't have permission to access this page.")}
			</Typography>
			<Flex gap={2}>
				{authenticated && (
					<>
						<Button variant="contained" onClick={() => void logout()}>
							{t("Logout")}
						</Button>
						{!noAvailablePlatforms && (
							<Button
								variant="contained"
								onClick={() => void navigate({ to: "/" })}
							>
								{t("Go to Home Page")}
							</Button>
						)}
					</>
				)}

				{!authenticated && (
					<Button
						variant="contained"
						onClick={() => void navigate({ to: "/login" })}
					>
						{t("Login")}
					</Button>
				)}
			</Flex>
		</Box>
	);
}
